import { render } from "./ProfileAddress.vue?vue&type=template&id=0a697216&scoped=true"
import script from "./ProfileAddress.vue?vue&type=script&lang=js"
export * from "./ProfileAddress.vue?vue&type=script&lang=js"

import "./ProfileAddress.vue?vue&type=style&index=0&id=0a697216&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a697216"]])

export default __exports__